import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

import { isEmpty } from '#imports'
import type Item from '~/stores/models/Item'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionProcessingDialog',
  props: {
  reorderable: {
    type: Boolean,
    default: false
  },
  validator: {
    type: Function as PropType<(item: Item) => string>,
    default: () => true
  },
  hideSelectionListing: {
    type: Boolean,
    default: false
  },
  disableProcessing: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {




const collections = useCollectionsStore()

const process = ref(collections.processingSelection)

function handleSelectProcess() {
  collections.processingSelection = process.value
}

function handleExecute() {
  collections.executeProcess()
}

function handleCancelProcessing() {
  // Close the dialog and clear the selection in case we want to try a different one
  collections.resetProcessing()
}

// Show the process selection when we don't have a process selected
const showSelectProcess = computed(() => {
  return isEmpty(collections.processingSelection)
})

// Show the options when we have selected a process and we don't have results yet
const showProcessOptions = computed(() => {
  return !isEmpty(collections.processingSelection) && isEmpty(collections.processResult) && !collections.processing
})

// Show the progress bar when processing
const showProcessProgress = computed(() => {
  return collections.processing
})

// Show the results when the processing is done and we have something in results
const showProcessResults = computed(() => {
  return !collections.processing && !isEmpty(collections.processResult)
})

// Allow reordering during options phase only
const reorderableDuringOptions = computed(() => {
  return __props.reorderable && showProcessOptions.value
})

const processingDialogTitle = computed(() => {
  if (showSelectProcess.value) {
    return 'Select Process'
  } else {
    return collections.processName
  }
})

const processingDialogSubtitle = computed(() => {
  if (showProcessOptions.value) {
    return 'Options'
  } else if (showProcessProgress.value) {
    return 'Processing...'
  } else if (showProcessResults.value) {
    return 'Results'
  }
})

onMounted(() => {
  collections.validateSelection(__props.validator)
})


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_hy_progress = _resolveComponent("hy-progress")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_CollectionSelection = _resolveComponent("CollectionSelection")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_hy_button = _resolveComponent("hy-button")!
  const _component_hy_dialog = _resolveComponent("hy-dialog")!

  return (_openBlock(), _createBlock(_component_hy_dialog, {
    modelValue: _unref(collections).processDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(collections).processDialog) = $event)),
    title: _unref(processingDialogTitle),
    subtitle: _unref(processingDialogSubtitle),
    width: "50%",
    persistent: "",
    "hide-close-button": ""
  }, {
    options: _withCtx(() => [
      (_unref(showSelectProcess) || _unref(showProcessOptions))
        ? (_openBlock(), _createBlock(_component_hy_button, {
            key: 0,
            type: "Cancel",
            disabled: _unref(collections).processing,
            onAction: handleCancelProcessing
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "actions", {}, () => [
        (_unref(showSelectProcess))
          ? (_openBlock(), _createBlock(_component_hy_button, {
              key: 0,
              type: "Next",
              primary: "",
              disabled: _unref(isEmpty)(_unref(process)) || !_unref(collections).hasSelection,
              onAction: handleSelectProcess
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_unref(showProcessOptions))
          ? (_openBlock(), _createBlock(_component_hy_button, {
              key: 1,
              type: "Process",
              primary: "",
              loading: _unref(collections).processing,
              disabled: __props.disableProcessing || _unref(collections).processing,
              onAction: handleExecute
            }, null, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true),
        (_unref(showProcessProgress))
          ? (_openBlock(), _createBlock(_component_hy_button, {
              key: 2,
              type: "Process",
              primary: "",
              loading: "",
              disabled: ""
            }))
          : _createCommentVNode("", true),
        (_unref(showProcessResults))
          ? (_openBlock(), _createBlock(_component_hy_button, {
              key: 3,
              type: "Done",
              primary: "",
              onAction: handleCancelProcessing
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_unref(showSelectProcess))
        ? (_openBlock(), _createBlock(_component_v_select, {
            key: 0,
            modelValue: _unref(process),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(process) ? (process).value = $event : null)),
            items: _unref(collections).processItems,
            label: "Process",
            variant: "solo-filled",
            density: "compact",
            flat: "",
            "hide-details": ""
          }, null, 8, ["modelValue", "items"]))
        : (_unref(showProcessOptions))
          ? _renderSlot(_ctx.$slots, "options", {}, undefined, undefined, 1)
          : (_unref(showProcessProgress))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "progress-name text-h6 mb-2" }, " Processing... ", -1)),
                _createVNode(_component_hy_progress, {
                  progress: _unref(collections).progress
                }, null, 8, ["progress"])
              ], 64))
            : _createCommentVNode("", true),
      (_unref(showProcessResults))
        ? _renderSlot(_ctx.$slots, "results", {}, undefined, undefined, 3)
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider, { class: "my-4" }),
      (!__props.hideSelectionListing)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 4,
            variant: "flat",
            rounded: "lg",
            "bg-color": "indigo-lighten-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CollectionSelection, {
                color: "indigo-lighten-5",
                reorderable: _unref(reorderableDuringOptions)
              }, null, 8, ["reorderable"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["modelValue", "title", "subtitle"]))
}
}

})